module.exports = __webpack_public_path__ + "img/Noor.cbc33592.svg";